import { Divider, message } from 'antd';
import React, { useEffect, useState } from 'react'
import { createSearchParams, useNavigate, useParams } from 'react-router-dom';
import CancelButton from '../../components/CancelButton';
import Head from '../../components/Head';
import Button from '../../components/UI/Button';
import Input from '../../components/UI/Input';
import Radio from '../../components/UI/Radio';
import SelectInput from '../../components/UI/SelectInput';
import SmartSearch from '../../components/UI/SmartSearch';
import SwitchInput from '../../components/UI/SwitchInput';
import { getLocationById, createOrUpdateLocation, validatePermitCode } from '../../services/locations';
import { notificationError } from '../../services/notification';
import { onlyLetters, onlyNumbers, onlySpaces } from '../../utils/formValidation';
import { findRelativeStatus } from '../../utils/objectUtils';
import { TimePicker } from 'antd'; 
import { onlyNumbersAsString, validateEmailsByComma } from '../../utils/stringUtils';
import { InputMode } from '../../enums/inputTypeEnum';
import { useLoading } from '../../context/LoadingProvider/useLoading';
import dayjs from "dayjs";

const format = 'HH:mm';

const statusSelectOptions = [
  {label: 'Active', value: 'Active'},
  {label: 'Closed', value: 'Closed'},
  {label: 'Inactive', value: 'Inactive'}
]
const locationSelectOptions = [
  {name: 'Bar', value: 'Bar'},
  {name: 'Booth', value: 'Booth'},
  {name: 'Bar and Booth', value: 'Bar and Booth'}
]

function NewLocation() {
  const history = useNavigate()
  const {id} = useParams()
  const loading = useLoading()
  const [validPermit, setValidPermit] = useState(true)

  const [charity, setCharity] = useState('')
  const [form, setForm] = useState({
    status: statusSelectOptions[0].value,
    charityId: "",
    name: "",
    address: "",
    zipcode: "",
    city: "",
    state: "",
    phone: "",
    email: "",
    operationalState: "Active",
    devicesLimit: "",
    permit: "",
    locationType: locationSelectOptions[0].value,
    drawerEnabled: "no",
    cashinLimit: "$200",
    posBundleServerEnabled: "yes",
    drawerHighCashNotificationEnabled: "no",
    disableDeckManagement: false,
    lateStartField: false,
    lateStart: '',
    earlyCloseField: false,
    earlyClose: '',
    allowSingleUse: false,
    dynamicBundleDownload: true,
    seasonal: false,
    checkSiteInactive: true,
    locationSpecificLobbyOrder: true,
    systemLocationSpecificLobbyOrder: false
  })
  const [orig, setOrig] = useState({
    status: statusSelectOptions[0].value,
    charityId: "",
    name: "",
    address: "",
    zipcode: "",
    city: "",
    state: "",
    phone: "",
    email: "",
    operationalState: "Active",
    devicesLimit: "",
    permit: "",
    locationType: locationSelectOptions[0].value,
    drawerEnabled: "no",
    cashinLimit: "$200",
    posBundleServerEnabled: "no",
    drawerHighCashNotificationEnabled: "no",
    disableDeckManagement: false,
    lateStartField: false,
    lateStart: '',
    earlyCloseField: false,
    earlyClose: '',
    allowSingleUse: false,
    dynamicBundleDownload: true,
    seasonal: false,
    checkSiteInactive: true,
    locationSpecificLobbyOrder: true
  })

  const initialize = async () => {
    loading.addLoading()
    const response = await getLocationById({id: id})
    setForm({
      status: findRelativeStatus(response.status, statusSelectOptions),
      charityId: response.charityId,
      name: response.name,
      address: response.address,
      zipcode: response.zipcode,
      city: response.city,
      state: response.state,
      phone: response.phone,
      email: response.email,
      operationalState: response.operationalState,
      devicesLimit: response.devicesLimit,
      permit: response.permit,
      locationType: response.locationType,
      cashinLimit: `$${response.cashinLimit}`,
      drawerEnabled: response.drawerEnabled === "true" ? 'yes' : 'no',
      posBundleServerEnabled: response.posBundleServerEnabled === "true" ? 'yes' : 'no',
      drawerHighCashNotificationEnabled: response.drawerHighCashNotificationEnabled === "true" ? 'yes' : 'no',
      disableDeckManagement: response.disableDeckManagement,
      lateStartField: !!response.lateStart,
      lateStart: response.lateStart || '00:00',
      earlyCloseField: !!response.earlyClose,
      earlyClose: response.earlyClose || '00:00',
      allowSingleUse: response.allowSingleUse.valueOf(),
      dynamicBundleDownload: response.dynamicBundleDownload.valueOf(),
      seasonal: response.seasonal.valueOf(),
      checkSiteInactive: response.checkSiteInactive.valueOf(),
      locationSpecificLobbyOrder: !!response.locationSpecificLobbyOrder,
      systemLocationSpecificLobbyOrder: response.locationSpecificLobbyOrder == null ? false : true
    })
    setOrig({
      status: findRelativeStatus(response.status, statusSelectOptions),
      charityId: response.charityId,
      name: response.name,
      address: response.address,
      zipcode: response.zipcode,
      city: response.city,
      state: response.state,
      phone: response.phone,
      email: response.email,
      operationalState: response.operationalState,
      devicesLimit: response.devicesLimit,
      permit: response.permit,
      locationType: response.locationType,
      cashinLimit: `$${response.cashinLimit}`,
      drawerEnabled: response.drawerEnabled === "true" ? 'yes' : 'no',
      posBundleServerEnabled: response.posBundleServerEnabled === "true" ? 'yes' : 'no',
      drawerHighCashNotificationEnabled: response.drawerHighCashNotificationEnabled === "true" ? 'yes' : 'no',
      disableDeckManagement: response.disableDeckManagement,
      lateStartField: !!response.lateStart,
      lateStart: response.lateStart || '00:00',
      earlyCloseField: !!response.earlyClose,
      earlyClose: response.earlyClose || '00:00',
      allowSingleUse: response.allowSingleUse.valueOf(),
      dynamicBundleDownload: response.dynamicBundleDownload.valueOf(),
      seasonal: response.seasonal.valueOf(),
      checkSiteInactive: response.checkSiteInactive.valueOf(),
      locationSpecificLobbyOrder: !!response.locationSpecificLobbyOrder
    })
    setCharity(response.charityName)
    loading.removeLoading()
  }

  useEffect(()=> {
    if(id) initialize()
  },[])

  const isChanged = () => {

    if(!form.name
        || !form.address
        || !form.zipcode
        || !form.city
        || !form.state
        || !form.phone
        || !form.status
        || !form.operationalState
        || !form.devicesLimit
        || !form.charityId
        || !form.permit
        || !form.locationType
        || !form.cashinLimit
        || !form.drawerEnabled
        || !form.posBundleServerEnabled
        || !form.drawerHighCashNotificationEnabled
    ) return false
    if(form.address!==orig.address) return true
    if(form.name!==orig.name) return true
    if(onlyNumbersAsString(form.zipcode)!==onlyNumbersAsString(orig.zipcode)) return true
    if(form.city!==orig.city) return true
    if(form.state!==orig.state) return true
    if(onlyNumbersAsString(form.phone)!==onlyNumbersAsString(orig.phone)) return true
    if(form.email!==orig.email) return true
    if(form.state!==orig.state) return true
    if(form.status!==orig.status) return true
    if(form.disableDeckManagement!==orig.disableDeckManagement) return true
    if(form.operationalState!==orig.operationalState) return true
    if(form.charityId!==orig.charityId) return true
    if(form.permit!==orig.permit) return true
    if(form.locationType!==orig.locationType) return true
    if(form.cashinLimit!==orig.cashinLimit) return true
    if(form.drawerEnabled!==orig.drawerEnabled) return true
    if(form.posBundleServerEnabled!==orig.posBundleServerEnabled) return true
    if(form.drawerHighCashNotificationEnabled!==orig.drawerHighCashNotificationEnabled) return true
    if(form.lateStartField!==orig.lateStartField) return true
    if(form.earlyClose!==orig.earlyClose) return true
    if(form.devicesLimit.toString()!==orig.devicesLimit.toString()) return true
    if(form.allowSingleUse !== orig.allowSingleUse) return true
    if(form.dynamicBundleDownload !== orig.dynamicBundleDownload) return true
    if(form.seasonal !== orig.seasonal) return true
    if(form.checkSiteInactive !== orig.checkSiteInactive) return true
    if (form.locationSpecificLobbyOrder !== orig.locationSpecificLobbyOrder) return true
    return form.earlyCloseField !== orig.earlyCloseField;

  }

  const submit = async () => {
    const {validEmails, invalidEmails} = validateEmailsByComma(form.email)
    const zipcode = onlyNumbersAsString(form.zipcode)
    if(parseInt(onlyNumbers(form.cashinLimit ) || '0') < 200) {
      return notificationError('Cashin Limit needs to be at least $200.00')
    }
    if(parseInt(onlyNumbers(form.cashinLimit )) > 9999) {
      return notificationError('Cashin Limit is $9999')
    }
    if(zipcode.length !== 5 && zipcode.length!==9 ) return notificationError('Zipcode must have between 5 or 9 numbers')
    if(!form.name || onlySpaces(form.name))return notificationError('Please insert name')
    if(!form.address || onlySpaces(form.address)) return notificationError('Please insert address')
    if(!form.city || onlySpaces(form.city)) return notificationError('Please insert city')
    if(!form.state || onlySpaces(form.state)) return notificationError('Please insert a state')
    if(!form.phone) return notificationError('Please insert a phone')
    const phone = onlyNumbersAsString(form.phone)
    if(phone.length < 10 || phone.length > 10 ) return notificationError('Phone must be 10 numbers')
    if(invalidEmails > 0) return notificationError('Please insert only valid emails')
    if(!form.devicesLimit) return notificationError('Please insert a device limit')
    if(!form.permit || onlySpaces(form.permit)) return notificationError('Please insert a premisses permit')
    if(!form.charityId) return notificationError('Please insert a charity')


    let res = false
    if(id) res = await createOrUpdateLocation({
      id,
      name: form.name,
      address: form.address,
      zipcode: form.zipcode,
      city: form.city,
      state: form.state,
      phone: form.phone,
      email: form.email,
      operationalState: "Active",
      devicesLimit: form.devicesLimit,
      permit: form.permit,
      locationType: form.locationType,
      cashinLimit: onlyNumbers(form.cashinLimit),
      drawerEnabled: form.drawerEnabled,
      posBundleServerEnabled: form.posBundleServerEnabled,
      drawerHighCashNotificationEnabled: form.drawerHighCashNotificationEnabled,
      disableDeckManagement: form.disableDeckManagement,
      earlyClose: form.earlyCloseField ? form.earlyClose : null,
      lateStart: form.lateStartField ? form.lateStart : null,
      allowSingleUse: form.allowSingleUse.valueOf(),
      dynamicBundleDownload: form.dynamicBundleDownload.valueOf(),
      seasonal: form.seasonal.valueOf(),
      checkSiteInactive: form.checkSiteInactive.valueOf(),
      locationSpecificLobbyOrder: form.locationSpecificLobbyOrder.valueOf()
    })
    
    if(!id) res = await createOrUpdateLocation({...form, cashinLimit: onlyNumbers(form.cashinLimit)})

    if(res) history({
      pathname:'/locations/',
      search: createSearchParams({
        useRecord: 'true'
      }).toString()
    })

  }

  const validateAndSetPermit = async (e: string, type: 'permit' | 'charityId') => {
    if(type === 'permit') setForm({...form, permit: e})
    if(type === 'charityId') setForm({...form, charityId: e})

    if((e.length > 2 && e.length < 5) && form.charityId) {
      const valid = await validatePermitCode({permit: e, charity_id: form.charityId, location_id: {id}.id})
      setValidPermit(valid)
    } else if (type === 'charityId' && form.permit.length > 2 && form.permit.length < 5) {
      const valid = await validatePermitCode({permit: form.permit, charity_id: e, location_id: {id}.id})
      setValidPermit(valid)
    }
    
  }

  const getPermitWargin = () => {
    if(!form.charityId && form.permit.length > 0) return 'Please insert a charity'
    return !validPermit &&  (`This permit code is already in use on ${charity}`)
  }

  const numberToCurrency = (value: string) => {
    let currency = onlyNumbers(value)
    if(parseInt(currency) > 9999) {
      notificationError('Cashin Limit is $9999')
      currency = "9999"
    }
    setForm({...form, cashinLimit: `$${currency}`})
  }

  return (
    <div className="new-distributor">
      <Head title={id ? 'Edit Location' : 'New Location'}/>
      <div className="new-distributor__container">
        <Divider orientation="left"><strong>General info</strong></Divider>
        <div className="new-distributor__container__row">
          <Input
            label="Name*"
            placeholder="Name"
            value={form.name}
            onChange={(e: any) => setForm({...form, name: e.target.value})}
          />
          <Input
            label="Address*"
            placeholder="Address"
            value={form.address}
            onChange={(e: any) => setForm({...form, address: e.target.value})}
          />
          <Input
            label="Zipcode*"
            placeholder="Zipcode"
            value={form.zipcode}
            onChange={(e: any) => setForm({...form, zipcode: onlyNumbers(e.target.value)})}
          />
          <Input
            label="City*"
            placeholder="City"
            value={form.city}
            onChange={(e: any) => setForm({...form, city: e.target.value})}
          />
          <Input
            label="State*"
            placeholder="State"
            value={form.state}
            onChange={(e: any) => e.target.value.length <= 2 && setForm({...form, state: onlyLetters( e.target.value)})}
            style={{width: 100}}
          />
          <Input
            onChange={(e) => setForm({...form, phone: e.target.value})}
            label='Phone*'
            placeholder='(000) 000-0000'
            value={form.phone || ''}
            inputMode={InputMode.PHONE}
          />

          <div className="input-component">
            <div className="input-component__label">
              Emails (comma separated)
            </div>
            <div  className="input-component__input">
              <input
                style={{width: '440px'}}
                className='ant-input'
                type="email" 
                placeholder="jon@jon.com, josh@josh.com"
                value={form.email}
                multiple
                onChange={(e: any) => {
                  setForm({...form, email: e.target.value})
                }}
              />
            </div>
          </div>
          <Radio
            innerProps={{id:'new-location-status'}}
            disabled={id ? true : false}
            label='Status*'
            value={form.status}
            onChange={(e: any) => setForm({...form, status: e.target.value})}
            options={statusSelectOptions} 
          />
          <SelectInput
            label="Type *"
            options={locationSelectOptions}
            value={form.locationType}
            onSelectChange={(e: any) => setForm({...form, locationType: e?.value ? e.value : e})}
          />
          {(!id || id==="") &&
          <SmartSearch
            disabled={id ? true : false}
            label="Charity *"
            searchBy={['charity']}
            value={charity}
            triggerWith={charity}
            status="active"
            onChange={(e: any) => setCharity(e)}
            onValidSearch={(e: any) => {}}
            onObjValueChange={(e) => validateAndSetPermit(e.id, 'charityId')}
          />}
          {id && id!=="" &&
              <Input
                  label="Charity"
                  placeholder="Charity"
                  value={charity}
                  onChange={(e: any) => {}}
                  innerProps={{id:'new-location-charity'}}
                  disabled={true}
              />
          }

        </div>
        <Divider orientation="left"><strong>Settings</strong></Divider>
        <div className="new-distributor__container__row">
          <Input
            label="Premises Permit *"
            placeholder="Premises Permit *"
            value={form.permit}
            onChange={(e: any) => validateAndSetPermit(e.target.value, 'permit')}
            warginig={getPermitWargin()}
          />
          <Input
            label="Devices Limit *"
            placeholder="Devices Limit *"
            value={form.devicesLimit}
            onChange={(e: any) => setForm({...form, devicesLimit: onlyNumbers(e.target.value)})}
          />
        </div>
        <Divider orientation="left"><strong>Drawer</strong></Divider>
        <div className="new-distributor__container__row">
          <SwitchInput
            label="Use Drawer on Point-Of-Sale"
            options={{check: 'yes', uncheck: 'no'}}
            onChange={(e: any) => {
              setForm({
                ...form, 
                drawerEnabled: e, 
                drawerHighCashNotificationEnabled: e === 'no' ? e : form.drawerHighCashNotificationEnabled
              })
            }}
            value={form.drawerEnabled}
          />
          <SwitchInput
            disabled={form.drawerEnabled === 'no'}
            label="Send email to charity when location closes drawer with excess cash"
            options={{check: 'yes', uncheck: 'no'}}
            onChange={(e: any) => setForm({...form, drawerHighCashNotificationEnabled: e})}
            value={form.drawerHighCashNotificationEnabled}
          />
        </div>
        <Divider orientation="left"><strong>POS</strong></Divider>
        <div className="new-distributor__container__row">
          <Input
            label="Cashin Limit (Only fill to increase the limit above the default $200.00)"
            placeholder="Cashin Limit"
            value={form.cashinLimit}
            onChange={(e: any) => numberToCurrency(e.target.value)}
          />
          <SwitchInput
            label="Allow POS to serve bundle to game terminals"
            options={{check: 'yes', uncheck: 'no'}}
            onChange={(e: any) => setForm({...form, posBundleServerEnabled: e})}
            value={form.posBundleServerEnabled}
          />
        </div>
        <Divider orientation="left"><strong>Deck</strong></Divider>
        <div className="new-distributor__container__row">
          <SwitchInput
            label="Allow Manufacturer, Distributor and Charity To Configure Decks At Decks Management Screen"
            options={{check: false, uncheck: true}}
            onChange={(e: any) => setForm({...form, disableDeckManagement: e})}
            value={form.disableDeckManagement}
          />
        </div>
        <Divider orientation="left"><strong>Start</strong></Divider>
        <div className="new-distributor__container__row">
          <SwitchInput
            label="Late start"
            options={{check: true, uncheck: false}}
            onChange={(e: any) => setForm({...form, lateStartField: e})}
            value={form.lateStartField}
          />
          {form.lateStartField && (
            <TimePicker 
              format={format} 
              use12Hours
              onChange={(e) => setForm({...form, lateStart: dayjs(e).format(format)})}
              defaultValue={dayjs(form.lateStart || '00:00:00', format)}
              style={{height: 32, marginTop: 20}}
            />
          )}
          <SwitchInput
            label="Early close"
            options={{check: true, uncheck: false}}
            onChange={(e: any) => setForm({...form, earlyCloseField: e})}
            value={form.earlyCloseField}
          />
          {form.earlyCloseField && (
            <TimePicker 
              format={format}
              use12Hours
              onChange={(e) => setForm({...form, earlyClose: dayjs(e).format(format)})}
              defaultValue={dayjs(form.earlyClose || '00:00:00', format)}
              style={{height: 32, marginTop: 20, marginRight: 20}}
            />
          )}
        </div>
        <Divider orientation="left"><strong>Single Use Devices</strong></Divider>
        <div className="new-distributor__container__row">
          <SwitchInput
              label="Configure single use devices"
              options={{check: true, uncheck: false}}
              onChange={(e: any) => setForm({...form, allowSingleUse: e})}
              value={form.allowSingleUse}
          />
        </div>
        <Divider orientation="left"><strong>Dynamic Bundle Download</strong></Divider>
        <div className="new-distributor__container__row">
          <SwitchInput
              label="Configure dynamic bundle download"
              options={{check: true, uncheck: false}}
              onChange={(e: any) => setForm({...form, dynamicBundleDownload: e})}
              value={form.dynamicBundleDownload}
          />
        </div>
        <Divider orientation="left"><strong>Other</strong></Divider>
        <div className="new-distributor__container__row">
          <SwitchInput
              label="Seasonal"
              options={{check: true, uncheck: false}}
              onChange={(e: any) => setForm({...form, seasonal: e})}
              value={form.seasonal}
          />
          <SwitchInput
              label="Enable Site Inactive Check"
              options={{check: true, uncheck: false}}
              onChange={(e: any) => setForm({...form, checkSiteInactive: e})}
              value={form.checkSiteInactive}
          />
          {form.systemLocationSpecificLobbyOrder && (
            <SwitchInput
              label="Enable Location Specific Lobby Order"
              options={{ check: true, uncheck: false }}
              onChange={(e: any) => setForm({ ...form, locationSpecificLobbyOrder: e })}
              value={form.locationSpecificLobbyOrder}
            />
          )}
        </div>
        <div className="new-distributor__container__actions">
          <CancelButton customRedirect={() => {
            history({
              pathname:'/locations/',
              search: createSearchParams({
                useRecord: 'true'
              }).toString()
            })
          }}/>
          <Button type="primary"
                  onClick={() => submit()}
                  disabled={!isChanged()}
          >
            <p id="save-button">Save</p>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default NewLocation
